import { render, staticRenderFns } from "./OperationsProductInventory.vue?vue&type=template&id=9dd6ebc8&scoped=true&"
import script from "./OperationsProductInventory.vue?vue&type=script&lang=js&"
export * from "./OperationsProductInventory.vue?vue&type=script&lang=js&"
import style0 from "./OperationsProductInventory.vue?vue&type=style&index=0&id=9dd6ebc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd6ebc8",
  null
  
)

export default component.exports